/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ChildDiaryEntry } from './childDiaryEntry';
import { ShipLogClassRecord } from './shipLogClassRecord';
import { ShipLogItemKindEnum } from './shipLogItemKindEnum';

/**
 * One feed item: either a class (Třídnice) record or an individual entry.
 */
export interface ShipLogItem { 
    kind: ShipLogItemKindEnum;
    date: string;
    classRecord: ShipLogClassRecord;
    entry: ChildDiaryEntry;
}